$(document).ready(function () {
  
  $(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
      if(scroll > height){
        $(".sticky-header").addClass("show");
      } else {
        $(".sticky-header").removeClass("show");
      } 
  });
  
  const max_allowed = document.querySelector('#checkboxes').getAttribute("max_allowed");
  $("#submit-btn").click(function () {
    $("#flexi-box-form")
      .find(":input")
      .each(function () {
        if ($(this).val() == "No") {
          $(this).prop("disabled", true);
        }
      });
    $(this).submit();
  });

  let checkboxes = $("input[type='checkbox']"),
    submitBtn = $("#submit-btn");

  checkboxes.click(function () {
    var n = $("input:checked").length;
    if (n == max_allowed) {
      submitBtn.css("display", "inline-block");
    } else {
      submitBtn.css("display", "none");
    }
    
    if(n>0){
      $("#checkbox_count").css("display", "inline-block");
      $("#checkbox_count").html(n);
    }
    else{
      $("#checkbox_count").css("display", "none");
    }
    
    $.each(checkboxes, function () {
      if (!$(this).is(":checked") && n == max_allowed) {
        $(this).prop("disabled", true);
      } else {
        $(this).prop("disabled", false);
      }
    });
  });
  
});